import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TenantManager from './../../components/tenantManager';
import tenants from './tenants';
import { OnboardingDialog } from './dialogs';
import { getJob } from './../../reducers/onboarding';
import { getRequirements } from './../../reducers/tenants';
import { getPendingJobRequirement } from '../../utilities/requirements';

import './onboarding.css';

class OnboardingPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = { dialogVisible: false };
        this.shouldBeVisible = this.shouldBeVisible.bind(this);
        this.setDialogVisibility = this.setDialogVisibility.bind(this);
    }

    componentDidMount() {
        const { role, requirements, getJob } = this.props;

        if (role.type === 'contractor') {
            let jobRequirement = getPendingJobRequirement(requirements);
            if (!jobRequirement || !jobRequirement.entity_id) return;
            getJob(jobRequirement.entity_id, response => this.setDialogVisibility(response.job.progress.step > 0 && !response.job.progress.help));
        }
    }

    shouldBeVisible() {
        const { role, job } = this.props;
        if (role.role === 'witness') return undefined;
        if (role.type === 'contractor' && (job.progress.step === 0 || job.progress.branch === 'ic-continue-request')) return undefined;

        return true;
    }

    setDialogVisibility(visible) {
        this.setState({ ...this.state, dialogVisible: visible });
    }

    render() {
        const { role, job } = this.props;
        const { dialogVisible } = this.state;
        if (role.type === 'contractor' && !job) return null;
        if (this.shouldBeVisible() && dialogVisible) {
            return <OnboardingDialog closeDialog={() => this.setDialogVisibility(false)} {...this.props} />;
        }

        return <TenantManager {...tenants} {...this.props} />;
    }
}

OnboardingPage.meta = {
    hide: true,
    lockout: true,
    locations: ['/onboarding']
};

const mapStateToProps = state => ({
    role: state.identity.role,
    job: state.onboarding.job
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getJob,
            getRequirements
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingPage);



// WEBPACK FOOTER //
// ./src/pages/onboarding/index.jsx